var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "c--shared_breadcrumb new-container mx-auto"
  }, [_c('div', {
    class: ['partner-with-us-breadcrumb mt-40 mb-20', {
      'display-none': _vm.deviceType.isMobile
    }]
  }, _vm._l(_vm.breadcrumbs, function (breadcrumb, index) {
    return _c('div', {
      key: `partner-with-us-breadcrumb-${index}`,
      staticClass: "partner-with-us-breadcrumb-item display-flex align-items-center"
    }, [breadcrumb.link && index !== _vm.breadcrumbs.length - 1 ? [_c('nuxt-link', {
      class: ['typo-p-small mb-0'],
      attrs: {
        "to": _vm.localePath(breadcrumb.link)
      }
    }, [_vm._v("\n          " + _vm._s(breadcrumb.title) + "\n        ")])] : [_c('p', {
      class: ['typo-p-small mb-0']
    }, [_vm._v("\n          " + _vm._s(breadcrumb.title) + "\n        ")])], _vm._v(" "), index !== _vm.breadcrumbs.length - 1 ? _c('span', {
      staticClass: "airalo-icon-arrow-right tw-text-3 tw-text-zinc-500 airalo-icon-wrapper"
    }) : _vm._e()], 2);
  }), 0)]);

}
var staticRenderFns = []

export { render, staticRenderFns }